module.exports = __webpack_public_path__ + "static/media/img_logout.9d7f12d3.png";